var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacilityicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 113,
    viewBox: "0 0 111 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M46.4001 50.0002C46.1001 51.0002 46.4001 56.6002 46.3001 59.4002C46.1001 61.4002 49.1001 61.0002 52.2001 61.0002C55.2001 60.8002 53.4001 55.2003 53.8001 51.2003C55.1001 49.2003 48.6001 48.1002 46.4001 50.0002Z",
    fill: "#1A3668"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M59.4997 63.9001C59.1997 64.9001 59.4997 70.5001 59.3997 73.3001C59.1997 75.3001 62.1997 74.9001 65.2997 74.9001C68.2997 74.7001 66.4997 69.1002 66.8997 65.1002C68.0997 63.1002 61.5997 62.0001 59.4997 63.9001Z",
    fill: "#1A3668"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M0.399902 52.8002C1.8999 130.3 115.1 131.8 110.2 57.2002C115.8 -15.3998 11.4999 -20.1998 0.399902 52.8002ZM72.1999 45.6002C75.3999 48.4002 74.0999 56.5001 73.3999 78.9001C71.1999 81.7001 69.3999 81.0002 67.9999 81.1002C31.1999 80.1002 40.4999 88.8001 39.1999 48.4001C39.3999 47.1001 39.9999 46.2002 40.5999 45.6002C38.2999 45.5002 35.9999 45.2002 33.7999 44.6002C32.7999 41.8002 36.7999 40.7002 38.6999 38.3002C44.3999 33.1002 49.5999 28.3001 55.4999 22.9001C57.7999 21.1001 62.0999 27.2001 61.7999 26.5001C80.0999 43.8001 85.9999 45.7002 72.1999 45.6002Z",
    fill: "#1A3668"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M59.5998 50.0002C59.2998 51.0002 59.5998 56.6002 59.4998 59.4002C59.2998 61.4002 62.2998 61.0002 65.3998 61.0002C68.3998 60.8002 66.5998 55.2003 66.9998 51.2003C68.2998 49.2003 61.6998 48.1002 59.5998 50.0002Z",
    fill: "#1A3668"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M46.3 63.9001C46 64.9001 46.3 70.5001 46.2 73.3001C46 75.3001 49 74.9001 52.1 74.9001C55.1 74.7001 53.3 69.1002 53.7 65.1002C55 63.1002 48.4 62.0001 46.3 63.9001Z",
    fill: "#1A3668"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityicon);
export default __webpack_public_path__ + "static/media/facilityicon.d4e939da3dbd470c43a48aec5c58f50d.svg";
export { ForwardRef as ReactComponent };